import MonthlyExpenseCloseScreen from "../components/MonthlyExpense/MonthlyExpenseCloseScreen";

export default function MonthlyExpenseClosePage() {
  return <MonthlyExpenseCloseScreen />;
}
